import React, { Component } from 'react';
import Page from './page';


class BoardDirectors extends Component {

    render() {
        return (
            <Page />
        );
    }
}
export default BoardDirectors;